module.exports = __webpack_public_path__ + "static/P2101546-7c142d0d338c8279596202bb561d8708.jpg";